/**
 * Motion presets — Apple HIG aligned (UX Pass 2 E3).
 *
 * Filosofia: motion explica hierarquia, nao decora. Easings calmos,
 * sem bounce overshoot, durations curtas (150-250ms).
 *
 * Use `useReducedMotion()` do framer-motion pra degradar
 * automaticamente. Estes presets ja respeitam o flag.
 */

import type { Transition, Variants } from 'motion/react';

/** Easing calmo Apple-like (ease-out cubic). */
export const easeCalm: Transition['ease'] = [0.16, 1, 0.3, 1];

/** Spring leve sem overshoot. */
export const springApple: Transition = {
  type: 'spring',
  stiffness: 300,
  damping: 28,
  mass: 0.8,
};

/** Spring micro pra hover/tap. */
export const springTap: Transition = {
  type: 'spring',
  stiffness: 400,
  damping: 17,
};

/** Durations padronizadas (ms). */
export const DURATION = {
  fast: 0.15,
  base: 0.2,
  slow: 0.25,
} as const;

/** Container stagger variants (mount entrance). */
export const containerStagger: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.05, delayChildren: 0.05 },
  },
};

/** Container stagger rapido pra rails horizontais. */
export const railStagger: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.04, delayChildren: 0.03 },
  },
};

/** Item: fade-up 8px (tiles, cards). */
export const fadeUpItem: Variants = {
  hidden: { opacity: 0, y: 8 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: DURATION.base, ease: easeCalm },
  },
};

/** Item: scale 0.96 -> 1 (stats). */
export const scaleInItem: Variants = {
  hidden: { opacity: 0, scale: 0.96 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: DURATION.base, ease: easeCalm },
  },
};

/** Hero header: slide-up 12px (uma vez por mount). */
export const heroEntry: Variants = {
  hidden: { opacity: 0, y: 12 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: DURATION.slow, ease: easeCalm, delay: 0.05 },
  },
};

/** Reduced-motion fallback: fade simples, sem deslocamento. */
export const reducedFade: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.12 } },
};

/** Helper: escolhe variants conforme reduced-motion. */
export function pickVariants(reduced: boolean, full: Variants): Variants {
  return reduced ? reducedFade : full;
}
